import axios from "axios"

const ExportHistoryService = {
    fetchHistory: async () => {
        const { data } = await axios.get(`export-history`)
        return data
    },
}

export default ExportHistoryService
